import type { NotificationItem } from '@/services/notification/type';

export const POLL_INTERVAL = 60 * 60 * 1000;
export const PAGE_SIZE = 10;

export interface TabState {
  items: NotificationItem[];
  page: number;
  hasMore: boolean;
}
